












import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class BoxDiagram extends Vue { 
	@Prop() public text!: string
	@Prop() public totalUnit!: number
	@Prop({ default: 210 }) public width!: string
}
